import React from "react";

import { StyledInput, Tag } from "../styles/global";

import { makeId } from "../utils/ui.utils";


interface Props {
  label: string;
  value: string;
  setValue: (value: any) => void;
  isValid?: (bool: boolean) => {};
  required?: boolean;
  requiredString?: string;
  setWidth?: number | string;
  title?: string;
}

export const DateInput = ({ title, label, value, setValue, isValid, required, requiredString, setWidth = 250 }: Props) => {
  const isValueValid = (value: any): boolean => {
    return (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      value !== "Invalid date"
    );
  };

  React.useEffect(() => {
    if (isValid) {
      isValid(isValueValid(value));
    }
  }, [value, isValid]);

  const helperText = (value: string): string | undefined => (required && value === '') || value === 'Invalid date' ? requiredString || `${label} required.` : undefined;
  return (
    <>
      {title && <Tag>{title}{required && ' *'}</Tag>}
      <StyledInput
        $setWidth={setWidth}
        id={`${makeId(label)}-input`}
        aria-label={label}
        type="datetime-local"
        label={label}
        required={required}
        error={!isValueValid(value)}
        helperText={helperText(value)}
        variant="outlined"
        onChange={(e: { target: { value: any; }; }) => {
          setValue(e.target.value)
        }}
        value={value}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </>
  );
};
